import React from 'react';

export const SidebarFooterCard = () => (
    <div className="card text-center">
        <div className="card-body">
            <i className="feather-sunrise fs-4 text-dark"></i>
            <h6 className="mt-4 text-dark fw-bolder">Bradev</h6>
        </div>
    </div>
);
